import { styled } from "@mui/material";

export const MailTemplateVisualEditorOptionsSection = styled('div')((props) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: props.theme.spacing(1),
    marginTop: props.theme.spacing(1)
}));